
// Definición de defaults

export const defaultTipoUsuario: TipoUsuarioProps = {
    idTipoUsuario:     0,
    descripcion:       '',
    activo:            false,
};

// Creación de interfaces

export interface TipoUsuarioProps {
    idTipoUsuario:     number;
    descripcion:       string;
    activo:            boolean;
}